import { BlockId } from '../../defs/block';
import { BlockEntity, spawnBlockEntity } from '../../entities/BlockEntity';
import { GameScene } from '../../GameScene';
import { blockViewAssets } from '../../util/blockTools';
import { IEffect } from './IEffect';

export type TvEffectOptions = {
  subject: BlockEntity;
};

const spawnId: BlockId = 'tvAll';

export class TvEffect implements IEffect {
  private readonly scene: GameScene;
  private readonly options: TvEffectOptions;

  constructor(scene: GameScene, options: TvEffectOptions) {
    this.scene = scene;
    this.options = options;
  }

  public static assets() {
    return blockViewAssets(spawnId);
  }

  public async execute() {
    // Spawn the tv block with noise
    spawnBlockEntity(
      this.scene,
      { id: spawnId },
      this.options.subject.c.position.mapPosition,
    );
  }
}
